module.exports = __webpack_public_path__ + "img/T5-A-rc_19.f7ba44a9.png";